export default "__VITE_ASSET__90a8b4ff__"